import { formatarComoMoeda, formatarData, formatarMoeda } from "../../contents/VariaveisGlobais"

const handleValorTotal = (item) => {
    const valor = item.value

    return formatarComoMoeda(valor, 2)
}

const handlePrecoUnitario = (item) => {
    const valor = item.value

    return formatarComoMoeda(valor, 4)
}

function handleData(item){
    return formatarData(item.value)
}

export { handlePrecoUnitario, handleValorTotal, handleData }